import React, { Component, Suspense, lazy } from 'react';
import { bool, number, string } from 'prop-types';
import { Rating, Button } from '@thd-olt-component-react/core-ui';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Histogram } from '@thd-olt-component-react/histogram';
import { extend } from '@thd-nucleus/data-sources';
import { CustomerImageCarousel } from './CustomerImageCarousel.component';
import * as analytics from '../../analytics';
import { ProductDetailsContext } from '../ProductDetailsContext';
import { ReviewsLoader } from './ReviewsLoader';
import { QuestionsAnswersLoader } from './QuestionsAnswersLoader';

let showAttributeRatings = false;

const hasPhotos = () => {
  showAttributeRatings = true;
};
class ProductDetailsRatings extends Component {

  // eslint-disable-next-line react/static-property-placement
  static contextType = ProductDetailsContext;

  tooltip = null;

  constructor(props) {
    super(props);
    this.state = {
      tooltipContent: <div>Loading...</div>
    };
  }

  onClick(event, qaselector, offsetselector, pageType, element) {
    this.scrollToReviews(event, qaselector, offsetselector);
    this.analyticsData(pageType, element);
  }

  getOffset = (offsetselector) => {
    return offsetselector && document.querySelector(`${offsetselector}`)
      ? document.querySelector(`${offsetselector}`).offsetHeight
      : null;
  };

  onToolTipLoad = (instance) => {
    this.tooltip = instance;
  };

  getProductObj = (reviewStats, totalResults) => {
    const { store } = reviewStats?.Includes?.Products || {};
    const reviewCount = store?.FilteredReviewStatistics?.TotalReviewCount;
    if (reviewCount === totalResults) {
      return store || null;
    }
    const itemObject = reviewStats?.Includes?.Products?.items
      ?.find((el) => el?.FilteredReviewStatistics?.TotalReviewCount === totalResults);
    return itemObject || store;
  }

  getRatingDistribution = (totalReviewCount, distribution) => {
    let stats = [{
      ratingValue: 5,
      count: 0,
      ratingPercentage: '0',
    },
    {
      ratingValue: 4,
      count: 0,
      ratingPercentage: '0',
    },
    {
      ratingValue: 3,
      count: 0,
      ratingPercentage: '0',
    },
    {
      ratingValue: 2,
      count: 0,
      ratingPercentage: '0',
    },
    {
      ratingValue: 1,
      count: 0,
      ratingPercentage: '0',
    },
    ];
    return stats.map((element) => {
      const starDistribution = distribution?.filter((el) => el.RatingValue === element.ratingValue)[0];
      if (starDistribution) {
        return {
          ratingValue: starDistribution.RatingValue,
          count: starDistribution.Count,
          ratingPercentage: Math.round((starDistribution.Count / totalReviewCount) * 100).toString(),
        };
      } return element;
    });
  };

  qaBadge = (qaStats) => {
    const {
      offsetselector,
      pageType,
      qaselector
    } = this.props;
    const qaTotalResults = qaStats?.TotalResults;

    const qaBVCount = qaTotalResults ? `(${qaTotalResults})` : '';

    return (
      <>
        <a
          className="product-details__question-and-answer"
          href={qaselector}
          onClick={(event) => this.onClick(event, qaselector, offsetselector, pageType, 'questions and answers')}
        >
          Questions & Answers {qaBVCount}
        </a>
      </>
    );
  };

  ratingsWithBadge = (reviewStats) => {
    const {
      offsetselector,
      pageType,
      target,
      totalReviewCount
    } = this.props;

    const { channel, product } = this.context;
    const TotalResults = reviewStats?.TotalResults;
    const { itemId } = product?.identifiers;
    const itemObj = this.getProductObj(reviewStats, TotalResults);
    const averageRating = itemObj?.FilteredReviewStatistics?.AverageOverallRating
    || product?.reviews?.ratingsReviews?.averageRating
    || 0;
    const totalReviews = TotalResults || product?.reviews?.ratingsReviews?.totalReviews || 0;
    const reviewCount = typeof TotalResults === 'number' ? TotalResults : totalReviewCount || totalReviews;
    const averageRatingNumber = Number(averageRating);
    const isMobile = channel === 'mobile';
    const hasAverageRating = averageRatingNumber > 0;
    const ratingsTitle = `${averageRatingNumber.toFixed(1)} out of 5`;
    let { tooltipContent } = this.state;
    return (
      <>
        {hasAverageRating && !isMobile
        && (
          <Tooltip
            channel={channel}
            content={tooltipContent}
            interactive
            onCreate={this.onToolTipLoad}
            placement="bottom"
          >
            <a
              className="product-details__rating-container"
              onClick={(event) => this.onClick(event, target, offsetselector, pageType, 'star rating')}
              onMouseOver={() => {
                this.setState({ tooltipContent: this.renderReview(reviewStats) });
                // eslint-disable-next-line no-unused-expressions
                this.forceRender;
              }}
              onFocus={this.forceRender}
              href={target}
              title={ratingsTitle}
            >
              <span
                id="product-details__review__target"
                className="product-details__BVRR-rating-normal-image"
              >
                <Rating className="product-details__ratings" value={averageRatingNumber} />
                <span className="product-details__review-count">
                  (
                  {reviewCount}
                  )
                </span>
              </span>
              <span className="product-details__tooltip" />
            </a>
          </Tooltip>
        )}
        {hasAverageRating && isMobile
        && (
          <a
            className="product-details__rating-container"
            onClick={(event) => this.onClick(event, target, offsetselector, pageType, 'star rating')}
            onFocus={this.forceRender}
            href={target}
            title={ratingsTitle}
          >
            <span
              id="product-details__review__target"
              className="product-details__BVRR-rating-normal-image"
            >
              <Rating className="product-details__ratings" value={averageRatingNumber} />
              <span className="product-details__review-count--mobile">
                (
                {reviewCount}
                )
              </span>
            </span>
            <span className="product-details__tooltip" />
          </a>
        )}
        {averageRatingNumber === 0 && (
          <div className="product-details__rating-favcount">
            <a
              className="product-details__rating-container"
              onClick={(err) => this.onClick(err, target, offsetselector, pageType, 'star rating')}
              href={target}
              title="Write the first Review"
            >
              <span className="product-details__BVRR-rating-normal-image">
                <Rating className="product-details__ratings" value={averageRatingNumber} />
              </span>
            </a>
          </div>
        )}
        {!isMobile
        && (
          <QuestionsAnswersLoader itemId={itemId}>
            {({ data, error, loading }) => {
              if ((error && !data) || !data?.questionsAnswers || loading) {
                return null;
              }
              return this.qaBadge(data.questionsAnswers);
            }}
          </QuestionsAnswersLoader>
        )}
      </>
    );
  };

  analyticsData = (pageType, element) => {
    analytics.track('click', {
      element
    });
  };

  ratingsWithRedirect = () => {
    const { target, pageType, disableReviewsIfZero } = this.props;
    const { product } = this.context;
    const { averageRating = 0, totalReviews = '0' } = product?.reviews?.ratingsReviews || {};
    const { canonicalUrl } = product?.identifiers;
    const ratingURL = canonicalUrl + target;
    const averageRatingNumber = Number(averageRating);

    if (totalReviews === '0' && disableReviewsIfZero) return null;

    return (
      <a
        className="product-details__rating-container"
        href={ratingURL}
        onClick={() => this.analyticsData(pageType, 'star rating')}
      >
        <span className="product-details__BVRR-rating-normal-image">
          <Rating className="product-details__ratings" value={averageRatingNumber} />
          <span className="product-details__review-count">
            (
            {totalReviews}
            )
          </span>
        </span>
      </a>
    );
  };

  attributeRatings = (secondaryRatingsAveragesRaw) => {
    if (!secondaryRatingsAveragesRaw) {
      return '';
    }
    const secondaryRatingsAverages = Object.values(secondaryRatingsAveragesRaw)?.filter((attribute) => attribute);
    return (
      <>
        {Array.isArray(secondaryRatingsAverages) && secondaryRatingsAverages.length > 1
          ? (
            <div className="product-details__secondary">
              <h3 className="product-details__secondary__heading">Attribute Ratings</h3>
            </div>
          ) : null}
        <div className="product-details__attributes">
          {(secondaryRatingsAverages || []).map((val, index) => {
            const averageRatingNumber = Number(val.AverageRating);
            if (averageRatingNumber) {
              return (
                <div key={index} className="product-details__id">
                  <span className="product-details__attributes-attribute"> {val.Id} </span>
                  <div className="product-details__ratings-dash">
                    <Rating className="product-details__ratings" type="dash" value={averageRatingNumber} orange />
                  </div>
                  <span>{averageRatingNumber.toFixed(1)}</span>
                </div>
              );
            }
            return null;
          })}
        </div>
      </>
    );
  };

  scrollToReviews = (event, target, offsetselector) => {
    event.preventDefault();
    if (target && offsetselector) {
      const targetElement = target
        ? document.querySelector(`${target}`)
        : null;
      if (typeof window !== 'undefined') {
        const targetLocation = this.targetPosition(targetElement) - this.getOffset(offsetselector);
        window.scroll({
          top: targetLocation,
          behavior: 'smooth'
        });
      }
    }
  };

  forceRender = (event) => {
    event.preventDefault();
    this.forceUpdate();
  };

  targetPosition = (element) => {
    const start = this.currentPosition();
    return element.getBoundingClientRect().top + start;
  };

  currentPosition = () => {
    return window.scrollY || window.pageYOffset;
  };

  renderReview = (reviewStats) => {
    const { Results: reviews } = reviewStats;
    if (!reviews) return null;
    const { product } = this.context;
    const { itemId } = product?.identifiers || {};
    const { target, offsetselector } = this.props;
    const totalResults = reviewStats?.TotalResults;
    const itemObj = this.getProductObj(reviewStats, totalResults);

    const secondaryRatingsAverages = itemObj?.FilteredReviewStatistics?.SecondaryRatingsAverages || null;
    const recommendedCount = itemObj?.FilteredReviewStatistics?.RecommendedCount || 0;
    const notRecommendedCount = itemObj?.FilteredReviewStatistics?.NotRecommendedCount || 0;
    const sumRecommended = recommendedCount + notRecommendedCount;
    const recommendationPercentage = sumRecommended ? Math.round((recommendedCount / sumRecommended) * 100) : 0;
    const ratingDistribution = itemObj?.FilteredReviewStatistics?.RatingDistribution || null;
    const ratingDistributionVal = this.getRatingDistribution(totalResults, ratingDistribution);
    return (
      <>
        <div className="product-details__wrapper product-details__wrapper--centered">
          <span className="product-details__percent">
            {recommendationPercentage}
            %
          </span>
          <span>
            &nbsp; of Customers Recommend
          </span>
        </div>
        <div className="product-details__wrapper">
          <h3 className="product-details__overall-rating"> Overall Ratings </h3>
          <Histogram
            totalReviews={totalResults}
            ratings={ratingDistributionVal}
          />
          <div>
            <CustomerImageCarousel
              itemId={itemId}
              tooltip={this.tooltip}
              hasPhotos={hasPhotos}
            />
          </div>
          { showAttributeRatings && secondaryRatingsAverages ? this.attributeRatings(
            secondaryRatingsAverages,
            target,
            offsetselector,
            totalResults
          ) : ''}
          <div className="product-details__ratings-button">
            <Button
              onClick={(event) => this.scrollToReviews(event, target, offsetselector)}
            >
              See All Reviews
            </Button>
          </div>
        </div>
      </>
    );
  };

  render() {
    const { product } = this.context;
    if (!product) return null;
    const { itemId } = product?.identifiers;
    const { showBadge } = this.props;
    return (
      <div className="product-details__review">
        {showBadge
        && (
          <ReviewsLoader itemId={itemId}>
            {({ data, error, loading }) => {
              if ((error && !data) || !data?.reviews || loading) {
                return null;
              }
              return this.ratingsWithBadge(data.reviews);
            }}
          </ReviewsLoader>
        )}
        {!showBadge && this.ratingsWithRedirect()}
      </div>
    );
  }
}

ProductDetailsRatings.propTypes = {
  offsetselector: string,
  pageType: string,
  qaselector: string,
  showBadge: bool,
  target: string,
  totalReviewCount: number,
  disableReviewsIfZero: bool
};

ProductDetailsRatings.defaultProps = {
  offsetselector: null,
  pageType: 'PIP',
  qaselector: null,
  showBadge: false,
  target: null,
  totalReviewCount: null,
  disableReviewsIfZero: false
};

ProductDetailsRatings.dataModel = extend(
  {
    ...ReviewsLoader.dataModel
  },
  QuestionsAnswersLoader,
  CustomerImageCarousel
);

export default ProductDetailsRatings;
